module.exports = __webpack_public_path__ + "img/FullCover_Eng3.31e60414.jpg";